module.exports = __webpack_public_path__ + "static/13-a3fa6a130e18c2828eaa3f45e98ae106.jpg";